// process.env.ASSETS_URL is inlined at build time by Bun's bundler (env: "inline").
// In dev, process is not defined in the browser, so we catch and fall back to /assets/.
const base = (() => {
  try {
    return (process.env.ASSETS_URL ?? "").replace(/\/$/, "");
  } catch {
    return "";
  }
})();

export function asset(path: string): string {
  const clean = path.replace(/^\//, "");
  return base ? `${base}/${clean}` : `/assets/${clean}`;
}
